export default __webpack_public_path__ + "static/media/hrm.71aa9774.svg";